// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchForm_root__LxODC","icon":"SearchForm_icon__jSm5O","input":"SearchForm_input__zKOkY","button":"SearchForm_button__EbEea"};